import type { NavigateFunction } from "react-router-dom";
import templateConfig from "../../../../config/templateConfig";

const ENTRY_PATHS = new Set(["/", "/app-entry"]);

function getPricingSectionId(): string {
  return templateConfig.home?.pricing?.id ?? "pricing";
}

/** Après navigation SPA, attendre le montage de la section cible. */
function scrollWhenReady(id: string, attemptsLeft = 40) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
  if (attemptsLeft <= 0) return;
  requestAnimationFrame(() => scrollWhenReady(id, attemptsLeft - 1));
}

/**
 * CTA navbar : ancrage sur la section « acteurs » (Pricing) de la page d'accueil.
 */
export function goToEntryPricingSection(pathname: string, navigate: NavigateFunction) {
  const id = getPricingSectionId();
  if (ENTRY_PATHS.has(pathname)) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      scrollWhenReady(id);
    }
    return;
  }
  void navigate({ pathname: "/", hash: id });
  scrollWhenReady(id);
}
